<template>
  <div v-if="show" class="userAgentController">
    <div>
      请注意，您使用的浏览器不是先进的浏览器，我们推荐您升级并使用微软最新浏览器，已获得最佳体验
    </div>
    <div class="marginLeft20">
      <a target="_blank" href="https://www.microsoft.com/zh-cn/edge">
        <el-button type="primary" icon="el-icon-download">
          点此下载最新浏览器
        </el-button>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false // 是否显示
    };
  },
  mounted() {
    const userAgent = navigator.userAgent;
    if (userAgent.indexOf("AppleWebKit") === -1) {
      this.show = true;
    }
  }
};
</script>
<style lang="less" scoped>
.userAgentController {
  padding: 10px 20px;
  color: white;
  display: flex;
  width: 100%;
  background-color: #0067b8;
  position: fixed;
  left: 0px;
  align-items: center;
  bottom: 0px;
}
</style>
